export default __webpack_public_path__ + "static/media/vitaminDfood-1132105308-770x553.39f50372.jpg";